import React from "react";

type Props = Readonly<{
  htmlContent: string | undefined;
  className?: string;
}>;

export const RawUhfContainer = ({ htmlContent, className }: Props) =>
  htmlContent ? (
    <div className={className} dangerouslySetInnerHTML={{ __html: htmlContent }} />
  ) : null;
